import { render, staticRenderFns } from "./SmplEditStamChild.vue?vue&type=template&id=27a6f4aa&scoped=true&"
import script from "./SmplEditStamChild.vue?vue&type=script&lang=js&"
export * from "./SmplEditStamChild.vue?vue&type=script&lang=js&"
import style0 from "./SmplEditStamChild.vue?vue&type=style&index=0&id=27a6f4aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a6f4aa",
  null
  
)

export default component.exports